// extracted by mini-css-extract-plugin
export var currencyInput = "_jz-1";
export var currencySymbol = "_jz-0";